import Spinner from "../Spinner/Spinner";

interface LoadingProps {
  minHeight?: string;
}

const Loading = ({
  minHeight = "calc(100vh - 286px)",
}: Readonly<LoadingProps>) => {
  return (
    <div
      className="flex w-full items-center justify-center"
      style={{ minHeight: minHeight }}
    >
      <Spinner className="border-b-els-blue mr-2" width="2rem" height="2rem" />
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
